import { render, staticRenderFns } from "./greennClub.vue?vue&type=template&id=067a636e&scoped=true&"
import script from "./greennClub.vue?vue&type=script&lang=js&"
export * from "./greennClub.vue?vue&type=script&lang=js&"
import style0 from "./greennClub.vue?vue&type=style&index=0&id=067a636e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067a636e",
  null
  
)

export default component.exports